import React from "react";
import { useTranslation } from "react-i18next";
import "./TermsAndConditions.css";
import { Heading } from "@americanexpress/dls-react";
import amexlogo from "../../assets/amex.png";

const TermsAndConditionsJapanContent = (props) => {
  const { t } = useTranslation("common");
  return (
    <>
      <div className="legal-1">{t("modal_japan.description")}</div>
      <div className="modalbox">
        <div className="modalcol1">
          <h4 className="modalheading">
            <b>{t("modal_japan.authusers")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal_japan.authusers1")} </li>
            <li>{t("modal_japan.authusers2")} </li>
            <li>{t("modal_japan.authusers3")} </li>
            <li>{t("modal_japan.authusers4")} </li>
            <li>{t("modal_japan.authusers5")}</li>
            <li>
              {t("modal_japan.authusers6")}
              <ol className="romanList">
                <li>{t("modal_japan.auth1")}</li>
                <li>{t("modal_japan.auth2")}</li>
              </ol>
            </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal_japan.regauthusers")}</b>
          </h4>
          <p className="desciption">{t("modal_japan.regauthdesc")}</p>
          <br />
        </div>

        <div className="modalcol2">
          <h4 className="modalheading">
            <b>{t("modal_japan.passwordusers")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal_japan.passwordusers1")} </li>
            <li>{t("modal_japan.passwordusers2")} </li>
            <li>{t("modal_japan.passwordusers3")} </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal_japan.license")}</b>
          </h4>
          <ol className="alphaList">
            <li>{t("modal_japan.license1")} </li>
            <li>
              {t("modal_japan.license2")}
              <ol className="romanList">
                <li>{t("modal_japan.licenseusers1")} </li>
                <li>{t("modal_japan.licenseusers2")} </li>
                <li>{t("modal_japan.licenseusers3")} </li>
                <li>{t("modal_japan.licenseusers4")} </li>
                <li>{t("modal_japan.licenseusers5")} </li>
              </ol>
            </li>
            <li>{t("modal_japan.license3")} </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal_japan.obligations")}</b>
          </h4>
          <p className="desciption">{t("modal_japan.obligationsdescrp")}</p>
          <h4 className="modalheading">
            <b>{t("modal_japan.terms")}</b>
          </h4>
          <ol className="alphaList">
            <li>
              {t("modal_japan.terms1")}
              <ol className="romanList">
                <li>{t("modal_japan.termsusers1")} </li>
                <li>{t("modal_japan.termsusers2")} </li>
                <li>{t("modal_japan.termsusers3")} </li>
              </ol>
            </li>
            <li>
              {t("modal_japan.terms2")}
              <ol className="romanList">
                <li>{t("modal_japan.termsusers4")} </li>
                <li>{t("modal_japan.termsusers5")} </li>
                <li>{t("modal_japan.termsusers6")} </li>
              </ol>
            </li>
          </ol>
          <h4 className="modalheading">
            <b>{t("modal_japan.services")}</b>
          </h4>
          <p style={{ paddingLeft: "10px" }} className="desciption">
            {t("modal_japan.servicesdescrp")}
          </p>
          <h4 className="modalheading">
            <b>{t("modal_japan.disclaimer")}</b>
          </h4>
          <p style={{ paddingLeft: "10px" }} className="desciption">
            {t("modal_japan.disclaimerdescrp")}
          </p>
          <h4 className="modalheading">
            <b>{t("modal_japan.specialProvisions")}</b>
          </h4>
          <ol className="alphaList">
            <li>
              {t("modal_japan.provisions1")}
              <ol className="romanList">
                <li>{t("modal_japan.provision1sub1")} </li>
                <li>{t("modal_japan.provision1sub2")} </li>
              </ol>
            </li>
            <li>{t("modal_japan.provisions2")} </li>
          </ol>
          {localStorage.getItem("lang") === "jap" ? null : (
            <p className="noteDesciption">{t("modal_japan.noteDocument")}</p>
          )}
          <br />
          <h4 className="modalEffective">{t("modal_japan.noteEffective")}</h4>
        </div>
      </div>

      {/* for Japnese Text */}
      {props.lang === "en" ? (
        <>
          <Heading level={1} headingStyle={"heading5"} className="margin-1-b">
            <img className="logo" src={amexlogo} alt="American Express" />{" "}
            {t("modal_engJapan.title")}
          </Heading>
          <div className="legal-1 pad-2-l">
            {t("modal_engJapan.description")}
          </div>
          <div className="modalbox">
            <div className="modalcol1">
              <h4 className="modalheading">
                <b>{t("modal_engJapan.authusers")}</b>
              </h4>
              <ol className="alphaList">
                <li>{t("modal_engJapan.authusers1")} </li>
                <li>{t("modal_engJapan.authusers2")} </li>
                <li>{t("modal_engJapan.authusers3")} </li>
                <li>{t("modal_engJapan.authusers4")} </li>
                <li>{t("modal_engJapan.authusers5")}</li>
                <li>
                  {t("modal_engJapan.authusers6")}
                  <ol className="romanList">
                    <li>{t("modal_engJapan.auth1")}</li>
                    <li>{t("modal_engJapan.auth2")}</li>
                  </ol>
                </li>
              </ol>

              <h4 className="modalheading">
                <b>{t("modal_engJapan.regauthusers")}</b>
              </h4>
              <p className="desciption">{t("modal_engJapan.regauthdesc")}</p>
              <br />
            </div>
            <div className="modalcol2">
              <h4 className="modalheading">
                <b>{t("modal_engJapan.passwordusers")}</b>
              </h4>
              <ol className="alphaList">
                <li>{t("modal_engJapan.passwordusers1")} </li>
                <li>{t("modal_engJapan.passwordusers2")} </li>
                <li>{t("modal_engJapan.passwordusers3")} </li>
              </ol>

              <h4 className="modalheading">
                <b>{t("modal_engJapan.license")}</b>
              </h4>
              <ol className="alphaList">
                <li>{t("modal_engJapan.license1")} </li>
                <li>
                  {t("modal_engJapan.license2")}
                  <ol className="romanList">
                    <li>{t("modal_engJapan.licenseusers1")} </li>
                    <li>{t("modal_engJapan.licenseusers2")} </li>
                    <li>{t("modal_engJapan.licenseusers3")} </li>
                    <li>{t("modal_engJapan.licenseusers4")} </li>
                    <li>{t("modal_engJapan.licenseusers5")} </li>
                  </ol>
                </li>
                <li>{t("modal_engJapan.license3")} </li>
              </ol>

              <h4 className="modalheading">
                <b>{t("modal_engJapan.obligations")}</b>
              </h4>
              <p className="desciption">
                {t("modal_engJapan.obligationsdescrp")}
              </p>
              <h4 className="modalheading">
                <b>{t("modal_engJapan.terms")}</b>
              </h4>
              <ol className="alphaList">
                <li>
                  {t("modal_engJapan.terms1")}
                  <ol className="romanList">
                    <li>{t("modal_engJapan.termsusers1")} </li>
                    <li>{t("modal_engJapan.termsusers2")} </li>
                    <li>{t("modal_engJapan.termsusers3")} </li>
                  </ol>
                </li>
                <li>
                  {t("modal_engJapan.terms2")}
                  <ol className="romanList">
                    <li>{t("modal_engJapan.termsusers4")} </li>
                    <li>{t("modal_engJapan.termsusers5")} </li>
                    <li>{t("modal_engJapan.termsusers6")} </li>
                  </ol>
                </li>
              </ol>
              <h4 className="modalheading">
                <b>{t("modal_engJapan.services")}</b>
              </h4>
              <p style={{ paddingLeft: "10px" }} className="desciption">
                {t("modal_engJapan.servicesdescrp")}
              </p>
              <h4 className="modalheading">
                <b>{t("modal_engJapan.disclaimer")}</b>
              </h4>
              <p style={{ paddingLeft: "10px" }} className="desciption">
                {t("modal_engJapan.disclaimerdescrp")}
              </p>
              <h4 className="modalheading">
                <b>{t("modal_engJapan.specialProvisions")}</b>
              </h4>
              <ol className="alphaList">
                <li>
                  {t("modal_engJapan.provisions1")}
                  <ol className="romanList">
                    <li>{t("modal_engJapan.provision1sub1")} </li>
                    <li>{t("modal_engJapan.provision1sub2")} </li>
                  </ol>
                </li>
                <li>{t("modal_engJapan.provisions2")} </li>
              </ol>
              <br />
              <h4 className="modalEffective">
                {t("modal_engJapan.noteEffective")}
              </h4>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default TermsAndConditionsJapanContent;
